import React, { useState } from 'react';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import styles from './upload-modal.scss';
import FileDropZone from '../../../../../../../components/FileDropZone.js';
import closeIcon from '../../../../../../../assets/close.svg';
import checkIcon from '../../../../../../../assets/check.svg';
import failIcon from '../../../../../../../assets/orders-table-reject.svg';
import ReportsService from '../../../../../../../services/reports-service.js';

const reportsService = new ReportsService();

const UploadModalContent = ({ context, onClose }) => {
  const { report } = context; 
  const [fileState, setFileState] = useState(null);
  const [uploadFlag, setUploadFlag] = useState(false);
  const [successMessage, setSuccessMessage] = useState({ msg: '', show: false });
  const [errorMessage, setErrorMessage] = useState({ msg: '', show: false });

  const formatDate = (dt) => new Date(dt).toISOString();

  const renderFileDropZone = () => {
    return fileState == null ? (
      <FileDropZone setFileHandler={(file) => {
        // console.log('File received:', file); // Log file details here
        setFileState(file);
      }} />
    ) : (
      <div className='file-detail'>
        <div className='close-icon' onClick={removeFile}>
          <img src={closeIcon} alt="Remove file" />
        </div>
        <div className='details'>
          <div>{fileState.name}</div>
          <div>{formatDate(fileState.lastModified)}</div>
        </div>
      </div>
    );
  };

  const removeFile = () => setFileState(null);

  const uploadFile = () => {
    // console.log(`filestate`, fileState);
    if (fileState) {
      const reader = new FileReader();
      
      reader.onloadend = () => {
        const base64File = reader.result.split(',')[1]; // Extract Base64 part
        
        if (base64File) {
          
          // Upload file to the API
          reportsService.uploadReport(
            report.type, 
            report.isin, 
            report.title, 
            report.paymentDate, 
            fileState.name, 
            base64File
          )
          .then(response => {
            // console.log('Response:', response);
            showSuccessMessage('File uploaded successfully!');
          })
          .catch(error => {
            console.error('Upload failed:', error);
            showErrorMessage('File upload failed!');
          });
        } else {
          console.error('Base64 encoding failed.');
          showErrorMessage('File encoding failed!');
        }
      };
      
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        showErrorMessage('Error reading file');
      };
  
      reader.readAsDataURL(fileState);  // Convert file to Base64
    }
  
    setUploadFlag(true);
    setTimeout(() => setUploadFlag(false), 1500);
  };

  const showSuccessMessage = (msg) => {
    setSuccessMessage({ msg, show: true });
    setTimeout(() => setSuccessMessage({ msg: '', show: false }), 3600);
  };

  const showErrorMessage = (msg) => {
    setErrorMessage({ msg, show: true });
    setTimeout(() => setErrorMessage({ msg: '', show: false }), 3600);
  };

  return (
    <div className='upload-modal-content'>
      <Row>
        {successMessage.show && (
          <div className='success-msg'>
            <img alt="Success" src={checkIcon} /> {successMessage.msg}
          </div>
        )}
        {errorMessage.show && (
          <div className='error-msg'>
            <img alt="Error" src={failIcon} /> {errorMessage.msg}
          </div>
        )}
      </Row>
      <div className='file-upload-area'>{renderFileDropZone()}</div>
      <Row>
        <Col>
          <div className='button-container'>
            <Button onClick={onClose} variant="secondary">
              Close
            </Button>
            <Button
              className={styles['btn']}
              disabled={fileState == null || uploadFlag}
              onClick={uploadFile}
            >
              {uploadFlag ? (
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              ) : (
                'Upload'
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UploadModalContent;
